import React from "react"
import { IoClose } from "react-icons/io5"
import PanelSidebarMenu from "../PanelSidebarMenu"
import SidebarLogo from "./SidebarLogo"

interface Props{
    handleCloseSidebar: any
}

const PanelSidebar: React.FC<Props> = ({ handleCloseSidebar }) => {
    return (
        <div className="hidden fixed w-64 md:flex h-screen" id="sidebar">
            <button className="hidden absolute z-50 -left-12 top-4" id="sidebar-close-icon" onClick={handleCloseSidebar}>
                <IoClose className="h-6 w-6 text-white text-4xl" />
            </button>
            <div className="bg-primary overflow-y-auto flex flex-col flex-grow pt-5" id="sidebar-content-layout">
                <SidebarLogo />
                <PanelSidebarMenu />
            </div>
        </div>
    )
}

export default PanelSidebar